import { type FrameworkType } from 'data-access/framework/types/framework.interface'
import { t } from '../helpers/t-converter'

export const frameworkTypeList = (type: FrameworkType): string => ({
  dynamicPurchasingSystem: t('Динамічна система закупівель'),
  electronicCatalogue: t('Кваліфікація в Prozorro Market'),
  internationalFinancialInstitutions: t('Виявлення зацікавленості')
}[type])

export const frameworkTypeName: Record<FrameworkType, string> = {
  dynamicPurchasingSystem: t('Динамічна система закупівель'),
  electronicCatalogue: t('Кваліфікація в Prozorro Market'),
  internationalFinancialInstitutions: t('Виявлення зацікавленості')
}
export const frameworkTypesList: FrameworkType[] = [
  'dynamicPurchasingSystem',
  'electronicCatalogue',
  'internationalFinancialInstitutions'
] as FrameworkType[]
